/* eslint-env browser */

import * as React from 'react'
const PropTypes = require('prop-types')
const axios = require('axios')

const Counterpart = require('@gandi/counterpart').Instance
const translate = new Counterpart()
translate.registerTranslations('en', require('./i18n/en'))
translate.registerTranslations('fr', require('./i18n/fr'))

const OneCatch = require('../../../client/clientjs/components/CatchesGrid/CatchItem')
const ArrayModal = require('../../../client/clientjs/components/Modals/ArrayModal')

class AllCatches extends React.Component {
  constructor() {
    super()
    this.state = {
      catches: [],
      catchesFetched: false,
      loadingMore: false,
      hasMore: true,
      arrayModalOpts: { isActive: false },
    }
    this.getCatches = this.getCatches.bind(this)
    this.onItemClick = this.onItemClick.bind(this)
    this.onHideArrayModal = this.onHideArrayModal.bind(this)
    this.showMore = this.showMore.bind(this)
  }

  componentWillMount() {
    if (this.props.appConfig.locale.identifierShort !== translate.getLocale()) {
      translate.setLocale(this.props.appConfig.locale.identifierShort)
    }
  }

  componentDidMount() {
    this.showMore()
  }

  onItemClick(e, id) {
    // modal not active on mobile
    if (window && window.matchMedia('(max-width: 770px)').matches) {
      return false
    }
    e.preventDefault()
    const { catches } = this.state
    const initialIndex = catches.findIndex(elt => elt.id === id) || 0

    this.setState({
      arrayModalOpts: {
        isActive: true,
        initialIndex,
        ids: catches.map(elt => elt.id),
        type: 'fishCatches',
      },
    })
    return true
  }

  onHideArrayModal() {
    this.setState({
      arrayModalOpts: { isActive: false },
    })
  }

  getCatches() {
    if (this.state.loadingMore) {
      return
    }

    this.setState({ loadingMore: true }, () => {
      const limit = 100
      let beforeDate = Date.now()
      if (this.state.catches && this.state.catches.length > 0) {
        beforeDate = new Date(this.state.catches[this.state.catches.length - 1].validationFirstDate).getTime()
      }
      axios
        .get(`/api/contests/${this.props.contestId}/validatedCatches`, {
          params: {
            limit,
            beforeDate,
          },
        })
        .then(res => {
          const actualCatches = this.state.catches || []
          const allCatches = actualCatches.concat(res.data)
          this.setState({
            catches: allCatches,
            catchesFetched: true,
            loadingMore: false,
            hasMore: res.data.length >= limit,
          })
        })
    })
  }

  showMore() {
    this.getCatches()
  }

  render() {
    const { catches, catchesFetched, hasMore, loadingMore, arrayModalOpts = { isActive: false } } = this.state
    const { appConfig } = this.props
    const { locale, isLoggedIn, userSettings } = appConfig

    const localShortIdentifier = locale.identifierShort

    return (
      <div className="columns is-mobile is-multiline is-centered">
        {catches.map(elt => (
          <div className="column is-6-mobile is-4-tablet is-3-desktop" key={elt.id} style={{ fontSize: '0.8em' }}>
            <OneCatch
              fishCatch={elt}
              actor={elt.creator}
              locale={localShortIdentifier}
              userSettings={userSettings}
              isLoggedIn={isLoggedIn}
              displayLikes={false}
              imageHeight={120}
              titleStyle={{ fontSize: 12 }}
              onClick={this.onItemClick}
            />
          </div>
        ))}
        <div className="is-12" style={{ paddingTop: 20, paddingBottom: 20, textAlign: 'center' }}>
          {catchesFetched && !loadingMore && hasMore && (
            <button onClick={this.showMore} type="button" className="button is-primary">
              {translate.translate('loadMore')}
            </button>
          )}
          {catchesFetched && loadingMore && (
            <button type="button" className="button is-primary is-loading">
              {translate.translate('loadMore')}
            </button>
          )}
          {!hasMore && catches.length > 0 && translate.translate('endOfFeed')}
        </div>
        <ArrayModal
          key="arrayModal"
          locale={appConfig.locale.identifierShort}
          onHide={this.onHideArrayModal}
          isLoggedIn={appConfig.isLoggedIn}
          userSettings={appConfig.userSettings}
          host={appConfig.config.host}
          {...arrayModalOpts}
        />
      </div>
    )
  }
}

AllCatches.propTypes = {
  appConfig: PropTypes.object.isRequired,
  contestId: PropTypes.string.isRequired,
  style: PropTypes.object,
}

AllCatches.defaultProps = {
  style: {},
}

module.exports = AllCatches
